import "vite/modulepreload-polyfill";

import { initializeApp } from "@js/vue/app.js";
initializeApp();

function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setVh();
window.addEventListener("resize", setVh);

import jumpLinks from "@js/jump-links.js";
jumpLinks();

import { setupParallaxElements, setupParallaxElementOverflow } from "@js/parallax.js";
setupParallaxElements();
setupParallaxElementOverflow(true);

import { onResize } from "@js/throttle.js"
onResize(() => {
	setupParallaxElementOverflow();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR")
	});
}
